/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import MediaDetailsForm from 'shared/ui/components/form-components/MediaDetailsForm.vue';
import MediaPlayer from 'shared/ui/components/media/MediaPlayer.vue';
import MediaDeleteAction from 'content-hub/components/modals/MediaDeleteAction.vue';

// Mixins
import contentActions from 'content-hub/mixins/content-actions';
import { setupExpirationTimeout } from 'libs/utils/cookies';

const __vue_script__ = {
    name: 'VideoLibraryDetails',

    components: {
        MediaPlayer,
        MediaDetailsForm,
    },

    mixins: [contentActions],

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            details: undefined,
            title: null,
            useCredentials: false,
            unsubscribers: []
        };
    },

    async created() {
        await this.getContentDetails();

        const onUpdateSignal = (signal) => {
            if (signal?.targetId === this.details?.id) {
                this.getContentDetails();
            }
        };

        this.unsubscribers.push(
            await this.$services.signal.addSignalListener(`document/${this.details.fp_type}/update`, onUpdateSignal),
            this.$services.signal.addEventListener('open', onUpdateSignal)
        );
    },

    beforeDestroy() {
        clearTimeout(this.expirationTimeoutId);
        this.unsubscribers.forEach(unsubscriber => unsubscriber());
        this.unsubscribers = [];
    },

    methods: {
        async getContentDetails() {
            const eventId = this.params.event._id;
            const modelId = this.$router.getRouteParams().modelId;

            try {
                this.details = await this.$services.content.getContentDetails(eventId, modelId);
                this.useCredentials = this.details.cookies;
                clearTimeout(this.expirationTimeoutId);
                this.expirationTimeoutId = setupExpirationTimeout(this.details.expires, () => this.getContentDetails());

            } catch (err) {
                this.backToMediaList();
            }

            this.details.eid = this.params.event._id;

            this.title = this.details.title;
        },

        backToMediaList() {
            const controller = this.$services.blueprint.getControllerByName('video-library', 'default');
            if (controller)
                this.$router.push(controller.route, {
                    eventId: this.params.event._id
                });
        },

        async promptDeletion() {
            this.$modal.show(MediaDeleteAction, {
                type: this.details.fp_type,
                delete: async () => {
                    await this.$services.content.deleteContent(this.details.eid, this.details.id);
                    this.backToMediaList();
                }
            }, {
                clickToClose: false,
                height: 'auto'
            });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.details
    ? _c("div", { staticClass: "contents-detail" }, [
        _c("header", [
          _c("div", { staticClass: "page-actions" }, [
            !_vm.details.upload_error && _vm.details.file_size
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-icon single download",
                    on: {
                      click: function ($event) {
                        return _vm.download(_vm.details)
                      },
                    },
                  },
                  [_c("i", { staticClass: "ic-download" })]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass: "btn btn-danger btn-icon single",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.promptDeletion()
                  },
                },
              },
              [_c("i", { staticClass: "ic-trash" })]
            ),
          ]),
          _c("h1", [
            _c(
              "div",
              {
                staticClass: "back-button",
                on: {
                  click: function ($event) {
                    return _vm.backToMediaList()
                  },
                },
              },
              [_c("i", { staticClass: "ic-chevron-left" })]
            ),
            _vm._v(_vm._s(_vm.title)),
          ]),
        ]),
        _c("section", { staticClass: "contents" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm.details.upload_error
                ? _c("div", { staticClass: "alert alert-error" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "file_upload.errors." + _vm.details.upload_error
                          )
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("media-details-form", {
                attrs: { details: _vm.details, event: _vm.params.event },
                on: {
                  titleChanged: function (newTitle) {
                    return (_vm.title = newTitle)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "video-preview" },
            [
              _c("media-player", {
                attrs: {
                  details: _vm.details,
                  "is-content-hub": false,
                  "use-credentials": _vm.useCredentials,
                },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/VideoLibraryDetails.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__